/**
 * Converts a string into a readable Title Case format.
 *
 * - Handles normal sentences (e.g., "hello world")
 * - Handles camelCase, PascalCase, snake_case, kebab-case, dot.case
 * - Replaces all delimiters with spaces
 * - Capitalizes the first letter of each word
 * - Normalizes internal casing (e.g., "NASAFlight" → "Nasa Flight")
 *
 * @param str - The input string to convert.
 * @returns The title-cased, space-separated string.
 *
 * @example
 * toTitleCase("helloWorld"); // "Hello World"
 * toTitleCase("this_is-anExample.string"); // "This Is An Example String"
 * toTitleCase("  hello   world "); // "Hello World"
 */
export function toTitleCase(str: string): string {
  return str
    .replace(/([a-zA-Z])(\d)/g, '$1 $2') // letter -> digit
    .replace(/(\d)([a-zA-Z])/g, '$1 $2') // digit -> letter
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // camelCase / PascalCase
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') // split acronyms from capitalized words
    .replace(/[_\-.]+/g, ' ') // snake_case, kebab-case, dot.case
    .trim()
    .split(/\s+/)
    .map((word) => {
      // Keep acronyms (all uppercase words) as-is
      if (word === word.toUpperCase() && word.length > 1) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}
